/**
 * CR-8193: "All call-off suppliers" on Stock Planning.
 *
 * Picking it puts every call-off supplier's parts in one grid: one row per
 * part and supplier, each row holding that supplier's own figures, with a
 * Supplier column so it is clear whose they are.
 */
import type { ColumnPreference, StockPlanningItem } from '../../../lib/api';

/** The supplier filter value (and `supplier_id` query value) for every supplier. */
export const ALL_SUPPLIERS = 'all';

/** What the supplier dropdown calls it. */
export const ALL_SUPPLIERS_LABEL = 'All call-off suppliers';

/**
 * Whether the supplier filter is set to every call-off supplier.
 *
 * @param supplierId - the Stock Planning supplier filter value
 * @returns true for "All call-off suppliers"
 */
export function isAllSuppliers(supplierId: string): boolean {
  return supplierId === ALL_SUPPLIERS;
}

/**
 * A row's identity in the grid. A part appears once per supplier in the
 * all-suppliers view, so the part id alone is not unique there.
 *
 * @param item - a grid row
 * @returns `"<part id>"`, or `"<part id>:<supplier id>"` on a combined grid
 */
export function rowKey(item: StockPlanningItem): string {
  return item.supplier_id ? `${item.id}:${item.supplier_id}` : String(item.id);
}

/**
 * The Supplier column of the all-suppliers grid. Display only: it is not one
 * of the user's saved columns, so it never appears in the Columns menu.
 */
export const SUPPLIER_COLUMN: ColumnPreference = {
  id: -1,
  column_id: 'supplier_name',
  label: 'Supplier',
  sort_order: -1,
  is_visible: true,
};
